(function() {
  'use strict';

  const sliderMap = new Map();
  let id = 0;

  function initSliders() {
    const sliders = document.querySelectorAll('.ott-collections-container');

    sliders.forEach(slider => {
      if (!slider.hasAttribute('data-ott-collection-id')) {
        slider.setAttribute('data-ott-collection-id', id++);
      }

      const collectionId = slider.dataset.ottCollectionId;
      if (sliderMap.has(collectionId)) {
        const originalInstance = sliderMap.get(collectionId);
        originalInstance.destroy();
        sliderMap.delete(collectionId);

        if (window.innerWidth < 768) {
          sliderMap.set(collectionId, originalInstance.rebuild());
        }

        return;
      }

      if (window.innerWidth < 768) {
        const sliderInstance = tns({
          container: slider,
          items: 1,
          loop: true,
          controls: true,
          prevButton: '.ott-collection-prev',
          nextButton: '.ott-collection-next',
          nav: true,
          navContainer: '.ott-collection-dots',
          gutter: 21,
          swipeAngle: false,
          autoWidth: true,
        });
        sliderMap.set(collectionId, sliderInstance);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initSliders);

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initSliders, 150);
  });
})();
